import router from '../../router'
import mainService from '../../services/mainService';

const state = {
    token: null,
    role: null,
    nickName: '',
    organizations: null, //organizations that user can see
    selectedOrganizationId: null,
    loginUsingTaxis: false,
    organizationEmployeeFullAccess: [], //list that holds the full access and organizationId of the logged user. Used to filter when one user (area 4) is assigned to more than one organizations.
    hasFullAccess: true
}


const getters = {
    getToken(state) {
        return state.token;
    },
    isAuthenticated(state) {
        return state.token != null;
    },
    isSuperAdmin(state) {
        return state.role == 1;
    },
    isAdmin(state) {
        return state.role == 2;
    },
    isRepresentative(state) {
        return state.role == 3;
    },
    isUser(state) {
        return state.role == 4;
    },
    getNickName(state) {
        return state.nickName;
    },
    getOrganizations(state) {
        return state.organizations;
    },
    getSelectedOrganizationId(state) {
        return state.selectedOrganizationId;
    },
    getHasFullAccess(state) {
        return state.hasFullAccess;
    }
};

const mutations = {
    authUser(state, userData) {
        state.token = userData.token;
        state.role = userData.role;
        state.nickName = userData.nickName;
        state.organizations = userData.organizations;
        state.selectedOrganizationId = userData.selectedOrganizationId;
        state.loginUsingTaxis = userData.loginUsingTaxis;
        state.organizationEmployeeFullAccess = userData.organizationEmployeeFullAccess;
        if (userData.organizationEmployeeFullAccess.length > 0) {
            state.hasFullAccess = userData.role == 4 ? userData.organizationEmployeeFullAccess.find(
                (x) => x.OrganizationId == userData.selectedOrganizationId
            ).HasFullAccess : true;
        } else {
            state.hasFullAccess = true;
        }

    },
    clearAuthData(state) {
        state.token = null;
        state.role = null;
        state.nickName = '';
        state.organizations = null;
        state.selectedOrganizationId = null;
        state.loginUsingTaxis = false;
        state.organizationEmployeeFullAccess = [];
        state.hasFullAccess = false;
    },
    setSelectedOrganizationId(state, selectedOrganizationId) {
        state.selectedOrganizationId = selectedOrganizationId;
        if (state.organizationEmployeeFullAccess.length > 0) {
            state.hasFullAccess = state.organizationEmployeeFullAccess.find(
                (x) => x.OrganizationId == selectedOrganizationId
            ).HasFullAccess;
        } else {
            state.hasFullAccess = true;
        }
    }
};

const actions = {

    setLogoutTimer(context, expiresIn) {
        setTimeout(() => {
            context.commit('clearAuthData');
            router.replace('/login');
        }, expiresIn * 60 * 1000);  //expiresIn in minutes
    },
    async login(context, authData) {
        const res = await mainService.post('/Security/Authenticate', authData);
        if (res.data.IsSuccess) {
            mainService.setAuthHeader(res.data.Token);
            const _res = await mainService.get('/Organizations/GetOrganizations');
            //to do check for organizations under this user.if not find then message "Μή έγκυρος χρήστης"              
            context.commit('authUser', {
                token: res.data.Token, role: res.data.Role, nickName: res.data.NickName, organizations: _res.data, organizationEmployeeFullAccess: res.data.OrganizationEmployeeFullAccess,
                selectedOrganizationId: _res.data[0].Id, loginUsingTaxis: false
            });
            context.dispatch('setLogoutTimer', res.data.ExpiresIn);
            const now = new Date();
            const expirationDate = new Date(now.getTime() + res.data.ExpiresIn * 60 * 1000);
            debugger;
            var hasFullAccess = res.data.Role == 4 ? res.data.OrganizationEmployeeFullAccess.find(x => x.OrganizationId == _res.data[0].Id).HasFullAccess : true;

            localStorage.setItem('token', res.data.Token);
            localStorage.setItem('expirationDate', expirationDate);
            localStorage.setItem('role', res.data.Role);
            localStorage.setItem('nickName', res.data.NickName);
            localStorage.setItem('organizations', JSON.stringify(_res.data));
            localStorage.setItem('selectedOrganizationId', JSON.stringify(_res.data[0].Id));
            localStorage.setItem('loginUsingTaxis', false);
            localStorage.setItem('organizationEmployeeFullAccess', JSON.stringify(res.data.OrganizationEmployeeFullAccess));
            localStorage.setItem('hasFullAccess', hasFullAccess);

            router.replace('/Home');
        }
    },
    async taxisLogin(context) {
        const res = await mainService.get('/Security/RedirectToTaxis');
        if (res.data.IsSuccess) {
            window.location = res.data.Message;
        }
    },
    async taxisAuthenticate(context, authCode) {
        const res = await mainService.get('/Security/AuthenticateUsingTaxis?authCode=' + authCode);
        if (res.data.IsSuccess) {
            mainService.setAuthHeader(res.data.Token);
            const _res = await mainService.get('/Organizations/GetOrganizations');
            context.commit('authUser', {
                token: res.data.Token, role: res.data.Role, nickName: res.data.NickName, organizations: _res.data, selectedOrganizationId: _res.data[0].Id,
                organizationEmployeeFullAccess: res.data.OrganizationEmployeeFullAccess, loginUsingTaxis: true
            });
            context.dispatch('setLogoutTimer', res.data.ExpiresIn);
            const now = new Date();
            const expirationDate = new Date(now.getTime() + res.data.ExpiresIn * 60 * 1000);
            var hasFullAccess = res.data.Role == 4 ? res.data.OrganizationEmployeeFullAccess.find(x => x.OrganizationId == _res.data[0].Id).HasFullAccess : true; localStorage.setItem('token', res.data.Token);
            localStorage.setItem('expirationDate', expirationDate);
            localStorage.setItem('role', res.data.Role);
            localStorage.setItem('nickName', res.data.NickName);
            localStorage.setItem('organizations', JSON.stringify(_res.data));
            localStorage.setItem('selectedOrganizationId', JSON.stringify(_res.data[0].Id));
            localStorage.setItem('loginUsingTaxis', true);
            localStorage.setItem('organizationEmployeeFullAccess', JSON.stringify(res.data.OrganizationEmployeeFullAccess));
            localStorage.setItem('hasFullAccess', hasFullAccess);

            router.replace('/Home');
        }
    },
    tryAutoLogin(context) {
        const token = localStorage.getItem('token');
        if (!token) {
            return
        }

        const expirationDate = Date.parse(localStorage.getItem('expirationDate'));
        const now = Date.now();
        //console.log(now-expirationDate);
        if (now >= expirationDate) {
            return
        }
        else {
            const role = localStorage.getItem('role');
            const organizations = JSON.parse(localStorage.getItem("organizations") || "[]");
            const organizationEmployeeFullAccess = JSON.parse(localStorage.getItem("organizationEmployeeFullAccess") || "[]");
            const selectedOrganizationId = parseInt(localStorage.getItem('selectedOrganizationId'));
            const nickName = localStorage.getItem('nickName');
            const loginUsingTaxis = localStorage.getItem('loginUsingTaxis');
            const hasFullAccess = localStorage.getItem('hasFullAccess');

            mainService.setAuthHeader(token);
            context.commit('authUser', {
                token: token, role: role, nickName: nickName, organizations: organizations, selectedOrganizationId: selectedOrganizationId,
                organizationEmployeeFullAccess: organizationEmployeeFullAccess, loginUsingTaxis: loginUsingTaxis
            });
        }
    },
    logout(context) {
        context.commit('clearAuthData');
        localStorage.removeItem('token');
        localStorage.removeItem('expirationDate');
        localStorage.removeItem('role');
        localStorage.removeItem('nickName');
        localStorage.removeItem('organizations');
        localStorage.removeItem('selectedOrganizationId');
        localStorage.removeItem('loginUsingTaxis');
        localStorage.removeItem('organizationEmployeeFullAccess');
        router.replace('/login');
    },
    setSelectedOrganizationId(context, organizationId) {
        context.commit('setSelectedOrganizationId', organizationId);
        localStorage.setItem('selectedOrganizationId', organizationId);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}